/** Query-param values and helpers for `/auth` routing — keeps history stacks small. */

/** @deprecated Legacy query param — no longer used; guests are never device-blocked. */
export const AUTH_DEVICE_LIMIT_REASON = 'device-limit';
export const AUTH_FROM_LANDING = 'landing';
/** Query value for `/auth?from=demo` — guest arrived from in-app save/signup CTAs. */
export const AUTH_FROM_DEMO = 'demo';

export const MARKETING_SITE_URL =
  process.env.REACT_APP_MARKETING_URL || 'https://flashcode.tech';

/**
 * Build a canonical `/auth` path. Prefer this over string concatenation so
 * redirects and links stay consistent and we avoid duplicate history entries.
 */
export function buildAuthPath({ mode, reason, from, language, ctaSource, ctaLocation } = {}) {
  const params = new URLSearchParams();
  if (mode === 'signup') {
    params.set('mode', 'signup');
  }
  if (reason) {
    params.set('reason', reason);
  }
  if (from) {
    params.set('from', from);
  }
  if (language) {
    params.set('language', String(language).trim());
  }
  if (ctaSource) {
    params.set('cta_source', String(ctaSource).trim());
  }
  if (ctaLocation) {
    params.set('cta_location', String(ctaLocation).trim());
  }
  const qs = params.toString();
  return qs ? `/auth?${qs}` : '/auth';
}

export function isDeviceLimitReason(searchParams) {
  return searchParams.get('reason') === AUTH_DEVICE_LIMIT_REASON;
}

/**
 * Where "back to marketing" should go when the user arrived from the landing
 * site. Returns null when we should not show a back affordance.
 */
export function resolveMarketingBackUrl(searchParams) {
  if (searchParams.get('from') === AUTH_FROM_LANDING) {
    return MARKETING_SITE_URL;
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return null;
  }

  try {
    const ref = document.referrer;
    if (!ref) return null;

    const refUrl = new URL(ref);
    const marketingUrl = new URL(MARKETING_SITE_URL);

    if (refUrl.origin === marketingUrl.origin) {
      return ref;
    }

    if (
      refUrl.origin === window.location.origin &&
      (refUrl.pathname === '/' || refUrl.pathname.endsWith('/landing.html'))
    ) {
      return refUrl.origin + '/';
    }
  } catch {
    /* malformed referrer — ignore */
  }

  return null;
}
